import { useEffect, useState } from "react"
import MiscServices from "@services/misc.services"
import { SelectOption, University } from "@interfaces/misc"
import { REGENCIES } from "@const/shared"

export function usePersonalOptions() {
  const [universities, setUniversities] = useState<University[]>([])
  const [uniOptions, setUniOptions] = useState<SelectOption[]>([])
  const [regencyOptions, setRegencyOptions] = useState<SelectOption[]>([])

  const misc = new MiscServices()

  useEffect(() => {
    const getUniversities = async () => {
      try {
        const res = await misc.getUniversities()

        if (res.isSuccess) {
          const result = res.getValue()
          setUniversities(result)
          const options = result.map((value) => {
            return {
              value: value.university_name,
              label: value.university_name,
            }
          })

          setUniOptions(options)
        }
      } catch (e) {
        console.log(e)
      }
    }

    function getRegencies() {
      const options = REGENCIES.map((value) => {
        return {
          value: value.regency_name,
          label: value.regency_name,
        }
      })

      setRegencyOptions(options)
    }

    getUniversities()
    getRegencies()
  }, [])

  return { universities, uniOptions, regencyOptions }
}
